
            import { pinCaptureHook } from "@/js/pin_capture_gps.js"
            export default pinCaptureHook
          